import { useContext, useEffect } from 'react'
import { PageTitleContext } from './PageTitleContext'

const usePageTitle = (value?: string) => {
  const setPageTitle = useContext(PageTitleContext)

  useEffect(() => setPageTitle(value), [value])
}

export default usePageTitle
